import { Log, Profile, VideoPlayer } from '@lightningjs/sdk'
import Hls from 'hls.js'

export default class PlayerHelper {
  constructor(consumer) {
    this.playerconsumer = consumer
    VideoPlayer.consumer(this.playerconsumer)

    this._player = null
  }

  initPlayer() {
    VideoPlayer.loader((url, videoEl) => {
      return new Promise(resolve => {
        const allowedExtentions = ['mp3', 'm3u8', 'aac', 'm4a']
        let extension =
          new URL(url).pathname
            .toLowerCase()
            .split('.')
            .pop() || null
        extension = allowedExtentions.includes(extension) ? extension : null
        const hls = extension === 'm3u8'

        if (hls) {
          Profile.operator().then(operator => {
            const HlsConfig = {
              debug: false,
              maxBufferHole: 10,
              highBufferWatchdogPeriod: 10,
              maxBufferSize: 30,
            }
            switch (operator) {
              case 'metrological':
              case 'sky':
                if (
                  this._player &&
                  this._player.destroy &&
                  typeof this._player.destroy === 'function'
                ) {
                  this._player.destroy()
                }

                this._player = new Hls(HlsConfig)
                this._player.loadSource(url)
                this._player.attachMedia(videoEl)

                this._player.on(Hls.Events.MANIFEST_PARSED, () => {
                  resolve()
                })

                this._player.on(Hls.Events.ERROR, (event, data) => {
                  this.playerconsumer.fire('$videoPlayerEvent', `HLS-${data.type}`, data)

                  if (data.fatal) {
                    switch (data.type) {
                      case Hls.ErrorTypes.MEDIA_ERROR:
                        this._player.recoverMediaError()
                        break

                      case Hls.ErrorTypes.NETWORK_ERROR:
                        this._player.startLoad()
                        break

                      default:
                        this._player.destroy()
                        break
                    }
                  }
                })
                break
              default:
                videoEl.setAttribute('src', url)
                videoEl.load()
                resolve()
                break
            }
          })
        } else {
          videoEl.setAttribute('src', url)
          Log.info('stream Extension:', extension)
          if (!extension) {
            videoEl.setAttribute('type', 'audio/aac')
          } else if (extension === 'm4a') videoEl.setAttribute('type', 'audio/m4a')
          videoEl.load()
          resolve()
        }
      })
    })

    VideoPlayer.unloader(videoEl => {
      return new Promise(resolve => {
        if (this._player && this._player.destroy && typeof this._player.destroy === 'function') {
          this._player.destroy()
        }
        videoEl.removeAttribute('type')
        videoEl.removeAttribute('src')
        videoEl.load()
        resolve()
      })
    })
  }
}
